"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPayTypeList = getPayTypeList;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
function getPayTypeList(query) {
  return (0, _requestPIM.default)({
    url: '/xyOrderPayment/page',
    method: 'get',
    params: query
  });
}